import React from 'react';
import {Collapse, Empty, Skeleton, Spin} from 'antd';
import "./style.less"

import {GeneralInfoTreeProps} from "../../types";
import {FinalGeneralInfoItem} from "../../../../types/generalInfo";

import GeneralInfoTreeChildren from "./tree-children/TreeChildren";
import {InfoCircleOutlined} from "@ant-design/icons";

const {Panel} = Collapse;


const GeneralInfoTree = (props: GeneralInfoTreeProps) => {
  const {generalInfoController} = props
  const {generalInfoItemsList} = generalInfoController


  const groupedByCategory: Record<string, FinalGeneralInfoItem[]> = generalInfoItemsList.filter(item => item.category).reduce((acc, item) => {
    if(item.category){
      acc[item.category] = acc[item.category] || [];
      acc[item.category].push(item);
    }

    return acc;
  }, {} as Record<string, FinalGeneralInfoItem[]>);


  const itemsWithoutCategory = generalInfoItemsList?.filter(item => !item.category)


  const categories = Object.entries(groupedByCategory)

  if (generalInfoController.isLoading && !generalInfoItemsList.length) {
    return <section className="general-information-section">
      <div className="general-information-intro">
        <Skeleton active title={{width: 280}} paragraph={{rows: 2}}/>
      </div>
      <div className="general-information-loading">
        {Array.from({length: 4}).map((_, index) => <Skeleton active key={index} paragraph={{rows: 1}}/>) }
      </div>
    </section>
  }

  return (
    <Spin spinning={generalInfoController.isLoading}>
      <section className="general-information-section">
        <div className="general-information-intro">
          <div className="general-information-intro__icon"><InfoCircleOutlined/></div>
          <div>
            <div className="general-information-intro__eyebrow">Корисні матеріали</div>
            <h1 className="general-information-intro__title">Інформація для громадян</h1>
            <p className="general-information-intro__description">
              Довідкова інформація, офіційні ресурси та документи, згруповані за темами.
            </p>
          </div>
        </div>

        {categories.length || itemsWithoutCategory.length ? <div className="general-information-content">
          {categories.length > 0 && <Collapse
            className="general-information-categories"
            defaultActiveKey={categories.map(([category]) => category)}
            expandIconPosition="right"
          >
            {categories.map(([category, items]) => <Panel
              header={<span className="general-information-category-title">
                <span>{category}</span>
                <span className="general-information-category-count">{items.length}</span>
              </span>}
              key={category}
            >
              <div className="general-information-items">
                {items.map((item) => <GeneralInfoTreeChildren
                  key={item.$id || `${category}-${item.title}`}
                  generalInfoController={generalInfoController}
                  item={item}
                />)}
              </div>
            </Panel>)}
          </Collapse>}

          {itemsWithoutCategory.length > 0 && <section className="general-information-uncategorized">
            <h2>Інші матеріали</h2>
            <div className="general-information-items">
              {itemsWithoutCategory.map((item) => <GeneralInfoTreeChildren
                key={item.$id || item.title}
                generalInfoController={generalInfoController}
                item={item}
              />)}
            </div>
          </section>}
        </div> : <div className="general-information-empty">
          <Empty description="Інформаційних матеріалів поки немає"/>
        </div>}
      </section>
    </Spin>
  );
};

export default GeneralInfoTree;
